// import React, { useState, useEffect, useRef } from 'react';
// import { useLocation } from 'react-router-dom';
// import Headroom from 'react-headroom';
// import './navbar.css';
// import { Link, NavLink } from 'react-router-dom';
// import { RiMenu3Line, RiCloseLine } from 'react-icons/ri';
// import logo from '../../../main_assets/logo.png';
// import { FaSearch, FaTimes } from "react-icons/fa";

// const Menu = ({ closeMenu, currentLocation, openSearch }) => (
//   <>
//     <p>
//       <NavLink to="/issues" exact className="nav-link" activeClassName="active" onClick={closeMenu}>
//         <i aria-hidden="true" className="home icon"></i>
//         Magazine
//       </NavLink>
//     </p>
//     <p>
//       <NavLink to="/articles" className="nav-link" activeClassName="active" onClick={closeMenu}>
//         Arcticles
//       </NavLink>
//     </p>
//     <p>
//       <NavLink to="/stories" className="nav-link" activeClassName="active" onClick={closeMenu}>
//         Stories
//       </NavLink>
//     </p>
//     <p>
//       <NavLink to="/case-study" className="nav-link" activeClassName="active" onClick={closeMenu}>
//         Case Studies
//       </NavLink>
//     </p>
//     <p>
//       <NavLink to="/events" className="nav-link" activeClassName="active" onClick={closeMenu}>
//         Events
//       </NavLink>
//     </p>
//     <div className="cart d-flex">
//       <div className="search-icon py-2 md:pl-12 text-dark" onClick={openSearch}>
//         <FaSearch />
//       </div>
//     </div>
//   </>
// );

// const Navbar = () => {
//   const [toggleMenu, setToggleMenu] = useState(false);
//   const [isSearchOpen, setIsSearchOpen] = useState(false);
//   const [searchQuery, setSearchQuery] = useState('');
//   const location = useLocation();
//   const menuRef = useRef(null);
//   const searchInputRef = useRef(null);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (menuRef.current && !menuRef.current.contains(event.target)) {
//         setToggleMenu(false);
//       }
//     };

//     document.addEventListener('mousedown', handleClickOutside);
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, []);

//   useEffect(() => {
//     if (isSearchOpen && searchInputRef.current) {
//       searchInputRef.current.focus();
//     }
//   }, [isSearchOpen]);

//   const closeMenu = () => {
//     setToggleMenu(false);
//   };

//   const openSearch = () => {
//     setIsSearchOpen(true);
//   };

//   const closeSearch = () => {
//     setIsSearchOpen(false);
//     setSearchQuery('');
//   };

//   const handleSearchSubmit = (e) => {
//     e.preventDefault();
//     // Implement your search logic here
//     console.log('Searching for:', searchQuery);
//     // You might want to navigate to a search results page or trigger a search function
//   };

//   return (
//     <>
//       <Headroom>
//         <div className="ulev__navbar">
//           <div className="ulev__navbar-links">
//             <div className="ulev__navbar-links_logo">
//               <Link to="/">
//                 <img src={logo} alt="logo" />
//               </Link>
//             </div>
//             <div className="ulev__navbar-links_container">
//               <Menu closeMenu={closeMenu} openSearch={openSearch} />
//             </div>
//             <div className="ulev__navbar-menu" ref={menuRef}>
//               {toggleMenu ? (
//                 <RiCloseLine color="#CD3333" size={27} onClick={() => setToggleMenu(false)} />
//               ) : (
//                 <RiMenu3Line color="#CD3333" size={27} onClick={() => setToggleMenu(true)} />
//               )}
//               {toggleMenu && (
//                 <div className="ulev__navbar-menu_container scale-up-center">
//                   <div className="ulev__navbar-menu_container-links">
//                     <Menu closeMenu={closeMenu} openSearch={openSearch} />
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </Headroom>

//       {/* Search Popup */}
//       {isSearchOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
//           <div className="bg-white rounded-lg shadow-xl w-11/12 max-w-md p-6 relative">
//             <button 
//               onClick={closeSearch} 
//               className="absolute top-4 right-4 text-gray-600 hover:text-gray-900"
//             >
//               <FaTimes size={24} />
//             </button>
//             <form onSubmit={handleSearchSubmit} className="w-full">
//               <div className="relative">
//                 <input 
//                   ref={searchInputRef}
//                   type="text" 
//                   placeholder="Search..." 
//                   value={searchQuery}
//                   onChange={(e) => setSearchQuery(e.target.value)}
//                   className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
//                 />
//                 <button 
//                   type="submit" 
//                   className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-600 hover:text-red-500"
//                 >
//                   <FaSearch size={20} />
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default Navbar;








// import React, { useState, useEffect, useRef } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { collection, query, where, getDocs, orderBy, limit } from 'firebase/firestore';
// import { db } from '../../../firebase'; 
// import Headroom from 'react-headroom';
// import './navbar.css';
// import { Link, NavLink } from 'react-router-dom';
// import { RiMenu3Line, RiCloseLine } from 'react-icons/ri';
// import logo from '../../../main_assets/logo.png';
// import { FaSearch, FaTimes } from "react-icons/fa";

// const Menu = ({ closeMenu, currentLocation, openSearch }) => (
//   <>
//     <p>
//       <NavLink to="/issues" exact className="nav-link" activeClassName="active" onClick={closeMenu}>
//         <i aria-hidden="true" className="home icon"></i>
//         Magazine
//       </NavLink>
//     </p>
//     <p>
//       <NavLink to="/articles" className="nav-link" activeClassName="active" onClick={closeMenu}>
//         Articles
//       </NavLink>
//     </p>
//     <p>
//       <NavLink to="/stories" className="nav-link" activeClassName="active" onClick={closeMenu}>
//         Stories
//       </NavLink>
//     </p>
//     <p>
//       <NavLink to="/case-study" className="nav-link" activeClassName="active" onClick={closeMenu}>
//         Case Studies
//       </NavLink>
//     </p>
//     <p>
//       <NavLink to="/events" className="nav-link" activeClassName="active" onClick={closeMenu}>
//         Events
//       </NavLink>
//     </p>
//     <div className="cart d-flex">
//       <div className="search-icon py-2 md:pl-12 text-dark" onClick={openSearch}>
//         <FaSearch />
//       </div>
//     </div>
//   </>
// );

// const SearchResults = ({ results, loading, error, onResultClick, searchQuery }) => {
//   if (!searchQuery) return null;
//   if (loading) {
//     return <div className="p-4 text-gray-600">Searching...</div>;
//   }
//   if (error) {
//     return <div className="p-4 text-red-500">{error}</div>;
//   }
//   if (!results.projects?.length && !results.news?.length && !results.events?.length) {
//     return <div className="p-4 text-gray-600">No results found for "{searchQuery}"</div>;
//   }

//   return (
//     <div className="max-h-96 overflow-y-auto bg-white rounded-lg shadow-lg">
//       {results.projects?.length > 0 && (
//         <div className="p-4 border-b">
//           <h3 className="font-bold mb-2">Projects</h3>
//           {results.projects.map(project => (
//             <div
//               key={project.id}
//               className="py-2 px-3 cursor-pointer hover:bg-gray-100 rounded"
//               onClick={() => onResultClick(`/projects/${project.slug || project.id}`)}
//             >
//               {project.title}
//             </div>
//           ))}
//         </div>
//       )}
      
//       {results.news?.length > 0 && (
//         <div className="p-4 border-b">
//           <h3 className="font-bold mb-2">Articles</h3>
//           {results.news.map(article => (
//             <div
//               key={article.id}
//               className="py-2 px-3 cursor-pointer hover:bg-gray-100 rounded"
//               onClick={() => onResultClick(`/articles/${article.slug || article.id}`)}
//             >
//               {article.title}
//             </div>
//           ))}
//         </div>
//       )}
      
//       {results.events?.length > 0 && (
//         <div className="p-4">
//           <h3 className="font-bold mb-2">Events</h3>
//           {results.events.map(event => (
//             <div
//               key={event.id}
//               className="py-2 px-3 cursor-pointer hover:bg-gray-100 rounded"
//               onClick={() => onResultClick(`/events/${event.id}`)}
//             >
//               {event.title}
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// const Navbar = () => {
//   const [toggleMenu, setToggleMenu] = useState(false);
//   const [isSearchOpen, setIsSearchOpen] = useState(false);
//   const [searchQuery, setSearchQuery] = useState('');
//   const [searchResults, setSearchResults] = useState({
//     projects: [],
//     news: [],
//     events: [],
//     loading: false,
//     error: null
//   });
  
//   const location = useLocation();
//   const navigate = useNavigate();
//   const menuRef = useRef(null);
//   const searchInputRef = useRef(null);
//   const searchIconRef = useRef(null);

//   const performSearch = async (query) => {
//     if (!query.trim()) {
//       setSearchResults({
//         projects: [],
//         news: [],
//         events: [],
//         loading: false,
//         error: null
//       });
//       return;
//     }

//     setSearchResults(prev => ({ ...prev, loading: true, error: null }));
//     const searchTerm = query.toLowerCase();

//     try {
//       // Search in projects
//       const projectsRef = collection(db, 'projects');
//       const projectsSnapshot = await getDocs(projectsRef);
//       const projectsResults = projectsSnapshot.docs
//         .map(doc => ({ id: doc.id, ...doc.data() }))
//         .filter(project => 
//           project.title?.toLowerCase().includes(searchTerm) ||
//           project.description?.toLowerCase().includes(searchTerm)
//         )
//         .slice(0, 5);

//       // Search in news
//       const newsRef = collection(db, 'news');
//       const newsSnapshot = await getDocs(newsRef);
//       const newsResults = newsSnapshot.docs
//         .map(doc => ({ id: doc.id, ...doc.data() }))
//         .filter(article => 
//           article.title?.toLowerCase().includes(searchTerm) ||
//           article.content?.toLowerCase().includes(searchTerm)
//         )
//         .slice(0, 5);

//       // Search in events
//       const eventsRef = collection(db, 'events');
//       const eventsSnapshot = await getDocs(eventsRef);
//       const eventsResults = eventsSnapshot.docs
//         .map(doc => ({ id: doc.id, ...doc.data() }))
//         .filter(event => 
//           event.title?.toLowerCase().includes(searchTerm) ||
//           event.description?.toLowerCase().includes(searchTerm)
//         )
//         .slice(0, 5);

//       setSearchResults({
//         projects: projectsResults,
//         news: newsResults,
//         events: eventsResults,
//         loading: false,
//         error: null
//       });
//     } catch (error) {
//       console.error('Search error:', error);
//       setSearchResults(prev => ({
//         ...prev,
//         loading: false,
//         error: 'Failed to perform search. Please try again.'
//       }));
//     }
//   };

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       if (searchQuery) {
//         performSearch(searchQuery);
//       }
//     }, 300);

//     return () => clearTimeout(timer);
//   }, [searchQuery]);

//   // ... Keep all the other useEffect hooks the same ...

//   const closeMenu = () => {
//     setToggleMenu(false);
//   };

//   const openSearch = () => {
//     setIsSearchOpen(true);
//   };

//   const closeSearch = () => {
//     setIsSearchOpen(false);
//     setSearchQuery('');
//     setSearchResults({
//       projects: [],
//       news: [],
//       events: [],
//       loading: false,
//       error: null
//     });
//   };

//   const handleSearchSubmit = (e) => {
//     e.preventDefault();
//     // Instead of navigating, just ensure we have results
//     if (searchQuery.trim()) {
//       performSearch(searchQuery);
//     }
//   };

//   const handleResultClick = (url) => {
//     navigate(url);
//     closeSearch();
//   };

//   return (
//     <div className="relative">
//       <Headroom>
//         <div className="ulev__navbar relative">
//           <div className="ulev__navbar-links">
//             <div className="ulev__navbar-links_logo">
//               <Link to="/">
//                 <img src={logo} alt="logo" />
//               </Link>
//             </div>
//             <div className="ulev__navbar-links_container">
//               <Menu closeMenu={closeMenu} openSearch={openSearch} />
//             </div>
//             <div className="ulev__navbar-menu" ref={menuRef}>
//               {toggleMenu ? (
//                 <RiCloseLine color="#CD3333" size={27} onClick={() => setToggleMenu(false)} />
//               ) : (
//                 <RiMenu3Line color="#CD3333" size={27} onClick={() => setToggleMenu(true)} />
//               )}
//               {toggleMenu && (
//                 <div className="ulev__navbar-menu_container scale-up-center">
//                   <div className="ulev__navbar-menu_container-links">
//                     <Menu closeMenu={closeMenu} openSearch={openSearch} />
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>

//           {/* Search Popup */}
//           {isSearchOpen && (
//             <div 
//               className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-start justify-center"
//               style={{ top: '0px', background: "#E9E9E1" }} 
//             >
//               <div className="w-full shadow-lg" style={{ marginTop: '0px', background: "#E9E9E1" }}> 
//                 <form onSubmit={handleSearchSubmit} className="container mx-auto px-4 py-6">
//                   <div className="relative">
//                     <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
//                       <FaSearch size={20} className="text-gray-600" />
//                     </div>
//                     <input 
//                       ref={searchInputRef}
//                       type="text" 
//                       placeholder="Search Design Cona..." 
//                       value={searchQuery}
//                       onChange={(e) => setSearchQuery(e.target.value)}
//                       className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:ring-2 pl-12 pr-12"
//                       style={{background: "#D9D9D9"}}
//                     />
//                     <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
//                       <button 
//                         type="button"
//                         onClick={closeSearch} 
//                         className="text-gray-600 hover:text-red-500 p-2"
//                       >
//                         <FaTimes size={20} />
//                       </button>
//                     </div>
//                   </div>
                  
//                   <div className="mt-4">
//                     <SearchResults 
//                       results={searchResults}
//                       loading={searchResults.loading}
//                       error={searchResults.error}
//                       onResultClick={handleResultClick}
//                       searchQuery={searchQuery}
//                     />
//                   </div>
//                 </form>
//               </div>
//             </div>
//           )}
//         </div>
//       </Headroom>
//     </div>
//   );
// };

// export default Navbar;







// import React, { useState, useEffect, useRef } from 'react';
// import { useLocation } from 'react-router-dom';
// import Headroom from 'react-headroom';
// import './navbar.css';
// import { db } from '../../../firebase';
// import { Link, NavLink } from 'react-router-dom';
// import { RiMenu3Line, RiCloseLine } from 'react-icons/ri';
// import logo from '../../../main_assets/logo.png';
// import { FaSearch, FaTimes } from "react-icons/fa";
// import { searchDatabase } from '../../../hooks/searchService';
// import SearchResults from '../../../containers/searchResults/SearchResults'


// const Menu = ({ closeMenu, currentLocation, openSearch }) => (
//   <>
//     <p>
//       <NavLink to="/issues" exact className="nav-link" activeClassName="active" onClick={closeMenu}>
//         <i aria-hidden="true" className="home icon"></i>
//         Magazine
//       </NavLink>
//     </p>
//     <p>
//       <NavLink to="/articles" className="nav-link" activeClassName="active" onClick={closeMenu}>
//         Arcticles
//       </NavLink>
//     </p>
//     <p>
//       <NavLink to="/stories" className="nav-link" activeClassName="active" onClick={closeMenu}>
//         Stories
//       </NavLink>
//     </p>
//     <p>
//       <NavLink to="/case-study" className="nav-link" activeClassName="active" onClick={closeMenu}>
//         Case Studies
//       </NavLink>
//     </p>
//     <p>
//       <NavLink to="/events" className="nav-link" activeClassName="active" onClick={closeMenu}>
//         Events
//       </NavLink>
//     </p>
//     <div className="cart d-flex">
//       <div className="search-icon py-2 md:pl-12 text-dark" onClick={openSearch}>
//         <FaSearch />
//       </div>
//     </div>
//   </>
// );

// const Navbar = () => {
//   const [toggleMenu, setToggleMenu] = useState(false);
//   const [isSearchOpen, setIsSearchOpen] = useState(false);
//   const [searchQuery, setSearchQuery] = useState('');
//   const location = useLocation();
//   const menuRef = useRef(null);
//   const searchInputRef = useRef(null);
//   const searchIconRef = useRef(null);
//   const [searchResults, setSearchResults] = useState([]);
//   const [isSearching, setIsSearching] = useState(false);
//   const [debouncedSearchQuery, setDebouncedSearchQuery] = useState('');
//   const searchTimeoutRef = useRef(null);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       // Close the menu when clicking outside
//       if (menuRef.current && !menuRef.current.contains(event.target)) {
//         setToggleMenu(false);
//       }
  
//       // Close the search results if clicked outside
//       if (isSearchOpen) {
//         const searchAreaClicked = searchInputRef.current && !searchInputRef.current.contains(event.target) &&
//                                   searchIconRef.current && !searchIconRef.current.contains(event.target);
        
//         // Ensure the click is outside the search results area as well
//         if (searchAreaClicked) {
//           closeSearch(); // Close the search results when clicking outside
//         }
//       }
//     };
  
//     // Add event listener for clicking outside
//     document.addEventListener('mousedown', handleClickOutside);
  
//     // Cleanup the event listener on component unmount
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, [isSearchOpen]);
  
  
  
  

//   useEffect(() => {
//     if (isSearchOpen && searchInputRef.current) {
//       searchInputRef.current.focus();
//     }
//   }, [isSearchOpen]);

//   const closeMenu = () => {
//     setToggleMenu(false);
//   };

//   const openSearch = () => {
//     setIsSearchOpen(true);
//   };

//   const closeSearch = () => {
//     setIsSearchOpen(false);
//     setSearchQuery('');
//   };


//   const handleSearchSubmit = async (e) => {
//     e.preventDefault();
//     if (!searchQuery.trim()) return;

//     setIsSearching(true);
//     try {
//       const results = await searchDatabase(db, searchQuery);
//       setSearchResults(results);
//     } catch (error) {
//       console.error('Search failed:', error);
//     } finally {
//       setIsSearching(false);
//     }
//   };

//   useEffect(() => {
//     if (searchTimeoutRef.current) {
//       clearTimeout(searchTimeoutRef.current);
//     }

//     if (searchQuery.trim()) {
//       searchTimeoutRef.current = setTimeout(() => {
//         setDebouncedSearchQuery(searchQuery);
//       }, 300); // 300ms delay
//     } else {
//       setSearchResults([]);
//       setDebouncedSearchQuery('');
//     }

//     return () => {
//       if (searchTimeoutRef.current) {
//         clearTimeout(searchTimeoutRef.current);
//       }
//     };
//   }, [searchQuery]);



//   // Add effect for performing search
//   useEffect(() => {
//     const performSearch = async () => {
//       if (!debouncedSearchQuery) return;

//       setIsSearching(true);
//       try {
//         const results = await searchDatabase(db, debouncedSearchQuery, 100); // Limit to 5 suggestions
//         setSearchResults(results);
//       } catch (error) {
//         console.error('Search failed:', error);
//       } finally {
//         setIsSearching(false);
//       }
//     };

//     performSearch();
//   }, [debouncedSearchQuery]);

//   const handleSearchInputChange = (e) => {
//     setSearchQuery(e.target.value);
//   };

//   return (
//     <div className="relative">
//       <Headroom>
//         <div className="ulev__navbar relative">
//           <div className="ulev__navbar-links">
//             <div className="ulev__navbar-links_logo">
//               <Link to="/">
//                 <img src={logo} alt="logo" />
//               </Link>
//             </div>
//             <div className="ulev__navbar-links_container">
//               <Menu closeMenu={closeMenu} openSearch={openSearch} />
//             </div>
//             <div className="ulev__navbar-menu" ref={menuRef}>
//               {toggleMenu ? (
//                 <RiCloseLine color="#CD3333" size={27} onClick={() => setToggleMenu(false)} />
//               ) : (
//                 <RiMenu3Line color="#CD3333" size={27} onClick={() => setToggleMenu(true)} />
//               )}
//               {toggleMenu && (
//                 <div className="ulev__navbar-menu_container scale-up-center">
//                   <div className="ulev__navbar-menu_container-links">
//                     <Menu closeMenu={closeMenu} openSearch={openSearch} />
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>

//           {isSearchOpen && (
//       <div 
//         className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-start justify-center"
//         style={{ top: '0px', background: "#E9E9E1" }} 
//       >
//         <div className="w-full shadow-lg" style={{ marginTop: '0px', background: "#E9E9E1" }}> 
//           <form onSubmit={handleSearchSubmit} className="container mx-auto px-4 py-6">
//             <div className="relative">
//               <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
//                 {isSearching ? (
//                   <div className="animate-spin h-5 w-5 border-2 border-gray-600 rounded-full border-t-transparent" />
//                 ) : (
//                   <FaSearch size={20} className="text-gray-600" />
//                 )}
//               </div>
//               <input 
//                 ref={searchInputRef}
//                 type="text" 
//                 placeholder="Search Design Cona..." 
//                 value={searchQuery}
//                 onChange={handleSearchInputChange}
//                 className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:ring-2 pl-12 pr-12"
//                 style={{background: "#D9D9D9"}}
//               />
//               <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
//                 <button 
//                   type="button"
//                   onClick={closeSearch} 
//                   className="text-gray-600 hover:text-red-500 p-2"
//                 >
//                   <FaTimes size={20} />
//                 </button>
//               </div>
//             </div>
//           </form>
          
//           {/* Live Search Results */}
//           {searchQuery.trim() && (
//             <div className="container mx-auto px-4 pb-6 max-h-[60vh] overflow-y-auto">
//               <SearchResults results={searchResults} />
//               {searchResults.length > 0 && (
//                 <div className="text-center mt-4">
//                   {/* <button
//                     onClick={handleSearchSubmit}
//                     className="text-blue-600 hover:underline"
//                   >
//                     View all results
//                   </button> */}
//                 </div>
//               )}
//             </div>
//           )}
//         </div>
//       </div>
//     )}
//         </div>
//       </Headroom>
//     </div>
//   );
// };

// export default Navbar;











// Navbar.jsx
import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Headroom from 'react-headroom';
import './navbar.css';
import { db } from '../../../firebase';
import { Link, NavLink } from 'react-router-dom';
import { RiMenu3Line, RiCloseLine } from 'react-icons/ri';
import logo from '../../../main_assets/logo.png';
import { FaSearch, FaTimes } from "react-icons/fa";
import { searchDatabase } from '../../../hooks/searchService';
import SearchResults from '../../../containers/searchResults/SearchResults';

const Menu = ({ closeMenu, currentLocation, openSearch }) => (
  <>
    <p>
      <NavLink to="/issues" exact className="nav-link" activeClassName="active" onClick={closeMenu}>
        <i aria-hidden="true" className="home icon"></i>
        Magazine
      </NavLink>
    </p>
    <p>
      <NavLink to="/articles" className="nav-link" activeClassName="active" onClick={closeMenu}>
        Arcticles
      </NavLink>
    </p>
    <p>
      <NavLink to="/stories" className="nav-link" activeClassName="active" onClick={closeMenu}>
        Stories
      </NavLink>
    </p>
    <p>
      <NavLink to="/case-study" className="nav-link" activeClassName="active" onClick={closeMenu}>
        Case Studies
      </NavLink>
    </p>
    <p>
      <NavLink to="/events" className="nav-link" activeClassName="active" onClick={closeMenu}>
        Events
      </NavLink>
    </p>
    <div className="cart d-flex">
      <div className="search-icon py-2 md:pl-12 text-dark" onClick={openSearch}>
        <FaSearch />
      </div>
    </div>
  </>
);

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const location = useLocation();
  const menuRef = useRef(null);
  const searchInputRef = useRef(null);
  const searchIconRef = useRef(null);
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState('');
  const searchTimeoutRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if click is outside both the menu and search area
      const isOutsideMenu = menuRef.current && !menuRef.current.contains(event.target);
      const isOutsideSearch = 
        searchInputRef.current && 
        !searchInputRef.current.contains(event.target) &&
        !event.target.closest('.search-results');

      if (isOutsideMenu) {
        setToggleMenu(false);
      }

      if (isOutsideSearch && isSearchOpen) {
        closeSearch();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isSearchOpen]);

  useEffect(() => {
    if (isSearchOpen && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [isSearchOpen]);

  const closeMenu = () => {
    setToggleMenu(false);
  };

  const openSearch = () => {
    setIsSearchOpen(true);
  };

  const closeSearch = () => {
    setIsSearchOpen(false);
    setSearchQuery('');
  };

  const handleSearchSubmit = async (e) => {
    e.preventDefault();
    if (!searchQuery.trim()) return;

    setIsSearching(true);
    try {
      const results = await searchDatabase(db, searchQuery);
      setSearchResults(results);
    } catch (error) {
      console.error('Search failed:', error);
    } finally {
      setIsSearching(false);
    }
  };

  useEffect(() => {
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    if (searchQuery.trim()) {
      searchTimeoutRef.current = setTimeout(() => {
        setDebouncedSearchQuery(searchQuery);
      }, 300);
    } else {
      setSearchResults([]);
      setDebouncedSearchQuery('');
    }

    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, [searchQuery]);

  useEffect(() => {
    const performSearch = async () => {
      if (!debouncedSearchQuery) return;

      setIsSearching(true);
      try {
        const results = await searchDatabase(db, debouncedSearchQuery, 100);
        setSearchResults(results);
      } catch (error) {
        console.error('Search failed:', error);
      } finally {
        setIsSearching(false);
      }
    };

    performSearch();
  }, [debouncedSearchQuery]);

  const handleSearchInputChange = (e) => {
    setSearchQuery(e.target.value);
  };

  return (
    <div className="relative">
      <Headroom>
        <div className="ulev__navbar relative">
          <div className="ulev__navbar-links">
            <div className="ulev__navbar-links_logo">
              <Link to="/">
                <img src={logo} alt="logo" />
              </Link>
            </div>
            <div className="ulev__navbar-links_container">
              <Menu closeMenu={closeMenu} openSearch={openSearch} />
            </div>
            <div className="ulev__navbar-menu" ref={menuRef}>
              {toggleMenu ? (
                <RiCloseLine color="#CD3333" size={27} onClick={() => setToggleMenu(false)} />
              ) : (
                <RiMenu3Line color="#CD3333" size={27} onClick={() => setToggleMenu(true)} />
              )}
              {toggleMenu && (
                <div className="ulev__navbar-menu_container scale-up-center">
                  <div className="ulev__navbar-menu_container-links">
                    <Menu closeMenu={closeMenu} openSearch={openSearch} />
                  </div>
                </div>
              )}
            </div>
          </div>

          {isSearchOpen && (
            <div 
              className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-start justify-center"
              style={{ top: '0px', background: "#E9E9E1" }} 
            >
              <div className="w-full shadow-lg" style={{ marginTop: '0px', background: "#E9E9E1" }}> 
                <form onSubmit={handleSearchSubmit} className="container mx-auto px-4 py-6">
                  <div className="relative">
                    <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
                      {isSearching ? (
                        <div className="animate-spin h-5 w-5 border-2 border-gray-600 rounded-full border-t-transparent" />
                      ) : (
                        <FaSearch size={20} className="text-gray-600" />
                      )}
                    </div>
                    <input 
                      ref={searchInputRef}
                      type="text" 
                      placeholder="Search Design Cona..." 
                      value={searchQuery}
                      onChange={handleSearchInputChange}
                      className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:ring-2 pl-12 pr-12"
                      style={{background: "#D9D9D9"}}
                    />
                    <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                      <button 
                        type="button"
                        onClick={closeSearch} 
                        className="text-gray-600 hover:text-red-500 p-2"
                      >
                        <FaTimes size={20} />
                      </button>
                    </div>
                  </div>
                </form>
                
                {searchQuery.trim() && (
                  <div className="container mx-auto px-4 pb-6 max-h-[60vh] overflow-y-auto">
                    <SearchResults 
                      results={searchResults}
                      onClickOutside={closeSearch}
                    />
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </Headroom>
    </div>
  );
};

export default Navbar;
